// extracted by mini-css-extract-plugin
export var cell = "_70-4";
export var headerCell = "_70-2";
export var rowHeader = "_70-3";
export var table = "_70-1";
export var tableContainer = "_70-0";